export default __webpack_public_path__ + "static/atato-d19baee08d2c699d8c45b4835f27499f.jpg";